import React from "react";
import { colors, DEFAULT_FONT } from "@util/constants";
import { Container } from "@util/standard";
import { SearchBox } from "react-instantsearch-dom";
import styled from "styled-components";
import IconButton from "./iconButton";
import { useStore } from "@state/store";

interface Props {
  indexName?: string;
  searchClient?: any;
  searchInput?: string;
}

const StyledSearchContainer = styled(Container)`
  margin-bottom: 15px;
  border-bottom: 1px solid;

  .ais-SearchBox-form {
    display: flex;
    flex: 1;
  }
  .ais-SearchBox {
    width: 100%;
  }
  .ais-SearchBox-input {
    display: flex;
    flex: 1;
    border: none;
    height: 44px;

    &:focus {
      outline: 0;
    }

    ::placeholder {
      color: var(--theme-primary-color);
      font-family: ${DEFAULT_FONT};
      font-size: 15px;
    }
  }
  .ais-SearchBox-submit {
    display: none;
  }
  .ais-SearchBox-reset {
    cursor: pointer;
    border: none;
    background-color: transparent;
    &:focus {
      outline: 0;
    }
  }

  input[type="search"]::-webkit-search-decoration,
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-results-button,
  input[type="search"]::-webkit-search-results-decoration {
    -webkit-appearance: none;
  }
`;

const update = (value: string) => {
  // updateSearchEntry(value);
  useStore.setState({
    searchParams: {
      searchString: value,
      hasSearched: value.length > 0 ? true : false,
      globalSearch: false,
    },
  });
};

const handleReset = () => {
  useStore.setState({
    searchParams: {
      searchString: "",
      hasSearched: false,
      globalSearch: false,
    },
  });
};

const SearchBar = (props: Props) => {
  return (
    <StyledSearchContainer>
      <SearchBox
        translations={{ placeholder: "Search" }}
        onChange={event => update(event.target.value)}
        onReset={handleReset}
      />
      <IconButton margin="auto" width="15px" height="15px" icon="searchDark" />
    </StyledSearchContainer>
  );
};

export default SearchBar;
